import React, { useCallback, useEffect } from 'react'

import DialogActions from '@material-ui/core/DialogActions'
import withStyles from '@material-ui/core/styles/withStyles'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import { TextField, Dialog, Button, CircularProgress } from '@material-ui/core'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import Slide from '@material-ui/core/Slide'
import DialogTitle from '@material-ui/core/DialogTitle'
import i18n from 'support/i18n'
import AuthMessageBox from 'components/auth_message_box/View'
import ButtonLink from 'components/button_link/View'
import {Link,useHistory } from 'react-router-dom'
import logo_red  from '../../../../img/innovate/Innovation_Logo.jpg'
import styles from './View.Style'
import { validateEmail } from 'pagesNewUi/signup/utils/security'
import images from 'common_constants/images'

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />
})

const ExternalLogin = props => {
  const history = useHistory()
  const {
    classes,
    // openDialog,
    // closeDialog,
    onExternalSubmit,
    isLogging,
    forgotPassword,
    isEmailNotVerifiedYet,
    messageText,
    messageType,
    onSendMeActivationEmailClick,
    resetAuthMessageBox,
  } = props

  const [loginData, setLoginData] = React.useState({
    email: '',
    password: '',
  })
  const [hasEmailError, setEmailError] = React.useState(false)

  useEffect(() => {
    resetAuthMessageBox()
  }, [])

  // function handleTextFieldChange(event) {
  //   const { name, value } = event.target
  //   const textField = { ...loginData, [name]: value }
  //   if (textField.email && hasEmailError) {
  //     setEmailError(false)
  //   }
  //   setLoginData(textField)
  // }

  const getEmailDomain = (email) => {
    if (!validateEmail(email)) return '';
    const parts = email.split('@');
    return parts.length === 2 ? parts[1].toLowerCase() : '';
  };
  
  const isVadafoneDomain = () => {
    const domain = getEmailDomain(loginData?.email);
    return domain === 'vodafone.com';
  };
  const isVadafoneDomainReturn = isVadafoneDomain()

  const handleTextFieldChange = useCallback((event) => {
    // handle click event
      const { name, value } = event.target
      const textField = { ...loginData, [name]: value }

    
      if (textField.email && hasEmailError) {
        setEmailError(false)
      }
      setLoginData(textField)
  }, [loginData]);

  
  const handleForgot = () => {
    if (!loginData.email) {
      setEmailError(true)
    } else {
      // closeDialog()
      forgotPassword(loginData.email)
    }
  }

  const handleClickSubmit = event => {
    event.preventDefault()
    if (!loginData.email) {
      setEmailError(true)
    } else {
      // closeDialog()
      onExternalSubmit(loginData.email, loginData.password)
    }
  }

  const handleClose = () => {
    // const { closeDialog} = props
    // closeDialog()
    history.push("/");
  }

  function renderMessageText() {

    if (isEmailNotVerifiedYet) {
      return (
        <div>
          <span>{i18n.t('COMMON_LOGIN.HEADER.EMAIL_NOT_CONFIRMED_YET')}</span>
          <ButtonLink
            classes={{ linkButton: classes.activationEmailLink }}
            onLinkClick={() => onSendMeActivationEmailClick(loginData.email)}
          >
            {i18n.t('COMMON_LOGIN.HEADER.RESEND_ACTIVATION_EMAIL')}
          </ButtonLink>
        </div>
      )
    }
    return messageText
  }

  return (
    <div className={classes.dialogRoot}>
      {/* <Dialog
        open={openDialog}
        aria-labelledby="form-dialog-title"
        TransitionComponent={Transition}
        maxWidth="md"
      > */}
        <AppBar position="absolute" style={{backgroundColor: '#fff'}}>
          <Toolbar>
            {/* <Typography variant="h6">Welcome!</Typography> */}
            <div className="nova-logo1">
              {/* <span className="nova-text">Innovate</span> */}
              <img className={classes.logored}  src={logo_red} alt="logo" />
              </div>
          </Toolbar>
        </AppBar>

        <DialogTitle id="form-dialog-title">Welcome Innovate!</DialogTitle>
        <form method="post" onSubmit={handleClickSubmit}>
          <DialogContent>
            <DialogContentText>
              Log in with your email and password. 
              {/* (Non Vodafone Users Only). */}
            </DialogContentText>
            <TextField 
              margin="normal"
              id="email"
              name="email"
              label="Email Address"
              type="email"
              fullWidth
              onChange={handleTextFieldChange}
              className={classes.textField}
              variant="outlined"
              error={hasEmailError}
              helperText={hasEmailError && i18n.t('COMMON_LOGIN.HEADER.MANDATORY_FIELD')}
            />
             {isVadafoneDomainReturn && (
              <div className="info-message">
                <small>Note: Users with @vodafone.com, please login with SSO. <a className="auth-link" href="/">Sign in here</a></small>
              </div>
            )}
            <TextField
              margin="normal"
              id="password"
              name="password"
              label="Password"
              type="password"
              fullWidth
              variant="outlined"
              className={classes.textField}
              onChange={handleTextFieldChange}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleForgot} color="primary" disabled={isVadafoneDomainReturn}>
              Forgot Password
            </Button>
            <Button onClick={handleClose} color="primary">
              Cancel{' '}
              {/* {isLogging && (
                <CircularProgress size={24} className={classes.buttonProgress} color="secondary" />
              )} */}
            </Button>
            <Button type="submit" onClick={handleClickSubmit} color="primary" disabled={isVadafoneDomainReturn}>
              {isLogging ? 'Loading...' : 'Login'}  
            </Button>
          </DialogActions>

          <AuthMessageBox messageType={messageType} messageText={renderMessageText()} />
        </form>
        {/* <AppBar position="relative" style={{backgroundColor: 'gray'}}> */}
          <div  style={{borderTop: '1px solid #333',padding:'1.125rem'}}>  Dont have an account?    <Link style={{color: '#e74c3c',marginLeft:'4px'}} to='/sign-up-new'>  Register Here </Link>
                
          </div>
        {/* </AppBar> */}

      {/* </Dialog> */}
    </div>
  )
}

export default withStyles(styles)(ExternalLogin)